import React, {useEffect, useState, Suspense} from 'react';
import {event, EVENT_TYPES} from '../../utils/event';

const PlayerModal = React.lazy(() => import('../modal/PlayerModal'));

function AppModal() {
	const [needPlayerModal, setNeedPlayerModal] = useState(false);

	useEffect(() => {
		const playerReadyCallback = () => {
			setNeedPlayerModal(true);
		};

		event.on(EVENT_TYPES.PLAYER_READY, playerReadyCallback);

		return () => {
			event.off(EVENT_TYPES.PLAYER_READY, playerReadyCallback);
		};
	}, []);

	return (
			<>
				{needPlayerModal && (
						<Suspense fallback={<></>}>
							<PlayerModal />
						</Suspense>
				)}
			</>
	);
}

export default AppModal;
